import { useAuth } from "react-oidc-context";
import { usePolicies } from "../auth/hooks.js";
import "oidc-client-ts";
import "rxjs";
import { Policy } from "./PoliciesAccessRule.js";
function useAccessPolicies() {
  const policies = usePolicies();
  return policies.map((p) => new Policy(p));
}
function useAuthAccessClaims(parser) {
  const { user } = useAuth();
  return parser.parse(user);
}
export {
  useAccessPolicies,
  useAuthAccessClaims
};
//# sourceMappingURL=hooks.js.map
